import React, { useEffect, useState, useMemo } from "react";
import Card from "./Card";
// import FormTextArea from "../FormTextArea";
// import { Form, Formik } from "formik";
// import * as Yup from "yup";
import Button from "./Button";
// import { DataContext } from "../../context/DataContext";
import axios from "axios";
import { getprofile_details } from "../../dependency/UtilityFunctions";
import { useHistory } from "react-router-dom";
import { toTitleCase } from "../../util/titleCase";

import ReactHtmlParser, {
  convertNodeToElement,
  processNodes,
} from "react-html-parser";
import { createEditor } from "slate";
import { Slate, Editable, withReact } from "slate-react";
import TextArea from "./TextArea";

// var fs = require("fs");

// import { DataContext } from '../context/DataContext';

// const homeworkSchema = Yup.object().shape({
//   homeworkText: Yup.string().required("Some text is required"),
// });

const HomeworkQuestions = ({ setShowModal }) => {
  // const dataContext = useContext(DataContext);
  const LSHomework = JSON.parse(localStorage.getItem("clickedHomework"));
  // const homework = dataContext.homework;
  const history = useHistory();
  // console.log(homework.assignment)
  // console.log(LSHomework.assignment)

  const schoolDomain = localStorage.getItem("schoolDomain");
  const idx = JSON.parse(localStorage.getItem("subSchoolData")).idx;

  const [fileInputState, setFileInputState] = useState("");
  const [selectedFile, setSelectedFile] = useState();
  const [fileName, setFileName] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [homeworkText, setHomeworkText] = useState("");
  const [uploaddata, setuploadedfile] = useState([]);
  const [studentDetails, setStudentDetails] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState([
    {
      type: "paragraph",
      children: [{ text: "" }],
    },
  ]);

  const editor = useMemo(() => withReact(createEditor()), []);

  useEffect(() => {
    getprofile_details().then((Details) => {
      // console.log(Details, "Details");
      if (studentDetails !== false) {
        setStudentDetails(Details);
      } else {
        setStudentDetails({});
      }
    });
  }, []);

  const handleFileInputChange = (e) => {
    console.log("click");
    const file = e.target.files[0];
    setSelectedFile(file);
    setFileInputState(e.target.value);
    UploadAssignmentAttachement(e.target.files);
  };

  const handleSubmitFile = (e) => {
    e.preventDefault();
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onerror = () => {
      console.error("AHHHHHHHH!!");
      setErrMsg("something went wrong!");
    };
  };

  const UploadAssignmentAttachement = (file) => {
    setFileName(file[0].name);

    let bodyFormData = new FormData();
    bodyFormData.append("SchoolUrl", schoolDomain);
    bodyFormData.append("uploadType", "assignment");
    bodyFormData.append("file[]", file[0]);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        // 'content-type': `multipart/form-data; boundary=${bodyFormData._boundary}`
      },
    };
    setIsUploading(true);
    axios
      .post(`student/testupload`, bodyFormData, config)
      .then((response) => {
        setIsUploading(false);

        console.log(response);
        // console.log(response.status)
        // DashboardStore.isprocessing = false
        let resp = response.data;
        // console.log(resp);

        if (response.status === 200) {
          let internalcode = resp.status;

          if (internalcode) {
            let uploadedFile = resp.data.Message;
            setuploadedfile(uploadedFile);
            // console.log(uploadedFile);
          } else {
            let Message = resp.data.Message;
            alert(Message);
          }
        } else {
          alert("An error occured while uploading...");
        }
      })
      .catch((err) => {
        alert("An error occured please try again later");
        // DashboardStore.isprocessing = false
        // toast.error('An Error Occured', {
        //     position: toast.POSITION.TOP_CENTER
        // });
        // console.log(err);
        setIsUploading(false);
      });
    // }
  };

  const hiddenFileInput = React.useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const submitAssignment = async () => {
    if (!homeworkText) {
      setLoading(false);
      alert("You cannot submit empty assignment");
      return;
    }
    // if (value[0].children[0].text === "" || value[0].children[0].text === "Write a note (compulsory)") {
    //   setLoading(false);
    //   alert("You cannot submit empty assignment");
    //   return;
    // }

    let admissionNumber = studentDetails.admissionnumber;

    let userUpload = uploaddata;
    let file_url;
    let attachmentextensionsub;
    let filename;

    if (userUpload.length > 0) {
      file_url = uploaddata[0]["fileUrl"];
      filename = uploaddata[0]["fileName"];
    }

    const FullPayload = {
      messagex: homeworkText,
      // messagex: value,
      assignmentidx: LSHomework.idx,
      schoolID: idx,
      SchoolUrl: schoolDomain,
      admissionnumber: admissionNumber,
      file_url,
      attachmentextensionsub,
      filename,
    };
    console.log(FullPayload);
    // return;
    try {
      setLoading(true);
      const { data } = await axios.post("/student/submithomework", FullPayload);
      console.log(data);
      // let Message = data.message;
      if (data.data.status) {
        alert(data.data.Message);
        console.log(data.data.Message);
        setLoading(false);
        setHomeworkText("");
        setTimeout(() => {
          history.push("/homework");
        }, 1000);
      } else {
        alert(`Submit failed. ${data.data.Message}`);
        setLoading(false);
        setHomeworkText("");
        setTimeout(() => {
          history.push("/homework");
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
      setHomeworkText("");
      // console.log(error);
      alert("An error Occured");
    }
  };

  function transform(node, index) {
    // all links must open in a new window
    if (node.type === "tag" && node.name === "a") {
      node.attribs.target = "_blank";
      return convertNodeToElement(node, index, transform);
    }

    if (node.type === "tag" && node.name === "button") {
      return (
        <Button key={index}>{processNodes(node.children, transform)}</Button>
      );
    }
  }

  const HtlmParserOptions = {
    decodeEntities: true,
    transform,
  };

  // console.log(value[0].children[0].text);
  console.log(homeworkText);

  return (
    <Card>
      <div className="py-6 px-4">
        <div className="flex sm:flex-row flex-col justify-start sm:justify-between sm:items-center pb-6 border-b-2 border-gray-600">
          <span className="flex mb-4 sm:mb-0">
            <span className="text-sm text-gray-100 font-semibold mr-1 leading-4">
              Teacher:
            </span>
            <span className="text-sm text-gray-400 font-semibold leading-4">
              {toTitleCase(LSHomework.creator)}
            </span>
          </span>
          <span className="flex">
            <span className="text-sm text-gray-100 font-semibold mr-1 leading-4">
              Due date:
            </span>
            <span className="text-sm text-gray-400 font-semibold leading-4">
              {LSHomework.duedate}
            </span>
          </span>
        </div>
        <div className="mt-5 h-72 overflow-auto">
          <div className="flex flex-col h-full">
            {ReactHtmlParser(LSHomework.assignment, HtlmParserOptions)}
          </div>
        </div>
      </div>
      {LSHomework.messagex ? (
        <div className="p-4 flex flex-col">
          <span className="text-gray-200 font-semibold pr-2">
            {" "}
            Your Answer:{" "}
          </span>
          <span>
            {" "}
            {ReactHtmlParser(LSHomework.messagex, HtlmParserOptions)}{" "}
          </span>
        </div>
      ) : (
        <>
          {window.location.host === "springlake.edves.net" ||
          window.location.host === "edvesqat.edves.net" ? (
            <div className=" py-4 px-1 sm:px-6 submitHmwrkShadow">
              <div className="mt-1">
                {/* <div className='bg-blue-900 border border-blue-800 p-4 h-full'> */}
                {/* <Slate
                  editor={editor}
                  value={value}
                  onChange={newValue => {
                      setValue(newValue);
                  }}
                >
                  <Editable
                    placeholder = "Write a note (compulsory)"
                    onKeyDown={event => {
                      if (event.key === '&') {
                        // Prevent the ampersand character from being inserted.
                        event.preventDefault()
                        // Execute the `insertText` method when the event occurs.
                        editor.insertText('and')
                      }
                    }}
                  />
                </Slate> */}
                {/* <Formik
                >
                  {() => (
                    <FormTextArea
                      ariaLabel="homework"
                      name="homeworkText"
                      type="text"
                      value={homeworkText}
                      placeholder="Write a note (compulsory)"
                      className="bg-blue-900 border-blue-800 w-full p-4"
                      handleChange={(e) => {
                        setHomeworkText(e.target.value);
                      }}
                    />
                  )}
                </Formik> */}
                {/* </div> */}
                <TextArea
                  ariaLabel="homework"
                  name="homeworkText"
                  type="text"
                  value={homeworkText}
                  placeholder="Write a note (compulsory)"
                  className="bg-blue-900 border-blue-800 w-full p-4"
                  onChange={(e) => {
                    setHomeworkText(e.target.value);
                  }}
                />
              </div>
              {uploaddata && uploaddata.length !== 0 && (
                <div className="my-4">
                  <span className="w-full flex justify-center items-center px-2 bg-gray-700 rounded">
                    <span className="mr-2 truncate text-blue-100 text-sm font-semibold">
                      {fileName}
                    </span>
                  </span>
                </div>
              )}
              <div className="mt-5">
                <form
                  onSubmit={handleSubmitFile}
                  className=" flex justify-between items-center"
                >
                  <div className="flex">
                    <span
                      onClick={handleClick}
                      className="flex bg-blue-900 cursor-pointer rounded px-1 py-3 sm:p-3"
                    >
                      <svg
                        width="11"
                        height="10"
                        viewBox="0 0 11 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 4.5H6V0.5C6 0.367392 5.94732 0.240215 5.85355 0.146447C5.75979 0.0526784 5.63261 0 5.5 0C5.36739 0 5.24021 0.0526784 5.14645 0.146447C5.05268 0.240215 5 0.367392 5 0.5V4.5H1C0.867392 4.5 0.740215 4.55268 0.646447 4.64645C0.552678 4.74021 0.5 4.86739 0.5 5C0.5 5.13261 0.552678 5.25979 0.646447 5.35355C0.740215 5.44732 0.867392 5.5 1 5.5H5V9.5C5 9.63261 5.05268 9.75979 5.14645 9.85355C5.24021 9.94732 5.36739 10 5.5 10C5.63261 10 5.75979 9.94732 5.85355 9.85355C5.94732 9.75979 6 9.63261 6 9.5V5.5H10C10.1326 5.5 10.2598 5.44732 10.3536 5.35355C10.4473 5.25979 10.5 5.13261 10.5 5C10.5 4.86739 10.4473 4.74021 10.3536 4.64645C10.2598 4.55268 10.1326 4.5 10 4.5Z"
                          fill="#439ADE"
                        />
                      </svg>
                      <span className="text-xs text-blue-100 leading-3 font-semibold">
                        Upload Document
                      </span>
                    </span>
                    <div className="text-xs font-semibold flex items-center text-black text-opacity-50 mt-4 ml-1">
                      {" "}
                      Maximum file size is 5MB{" "}
                    </div>
                  </div>
                  <input
                    id="fileInput"
                    type="file"
                    accept=".jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    ref={hiddenFileInput}
                    name="file"
                    onChange={handleFileInputChange}
                    value={fileInputState}
                    style={{ position: "absolute", top: "-9999px" }}
                  />
                  <Button
                    type="submit"
                    text={isUploading === true ? "Uploading" : "Submit"}
                    onClick={submitAssignment}
                    loading={isUploading || loading}
                    //   loadingText=""
                  />
                </form>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </Card>
  );
};

export default HomeworkQuestions;